import { changeLinkTargetMode, getLinkTargetMode } from '../../components/link-target-utils';

interface MenuRecord {
    title?: string;
    description?: string;
    customPageId?: number;
    url?: string;
}

// Reenvia o registro atual alterando só a visibilidade; mantém apenas o destino ativo (página ou URL)
export function buildVisibilityRequest<T extends MenuRecord>(record: T, isVisible: boolean, withDescription: boolean) {
    return {
        title: record.title,
        description: withDescription ? record.description : undefined,
        ...changeLinkTargetMode(record, getLinkTargetMode(record)),
        isVisible,
    };
}
